export function bpsToString(bps: number) {
  return `${bps / 100}%`;
}
